import { render } from "./SearchHistory.vue?vue&type=template&id=7ade3d8c"
import script from "./SearchHistory.vue?vue&type=script&lang=js"
export * from "./SearchHistory.vue?vue&type=script&lang=js"

import "./SearchHistory.vue?vue&type=style&index=0&id=7ade3d8c&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__